import React, { useCallback, useEffect, useState } from 'react';
import { filter, findIndex, sumBy } from 'lodash';

import { getOrderItemPrice, isAddonProduct } from '@/components/modals/SubmitOrder/constants';
import { useOrderContext, useOrderDispatch } from '@/components/modals/SubmitOrder/helpers';

import { OrderBlock } from '../../../Common/OrderBlock';
import { ProductDescription } from '../ProductDescription';
import { ProductQuantity } from '../ProductQuantity';
import { isProductAvailable } from '../SelectServices/constants';

export const AddonsDetails = () => {
  const state = useOrderContext();
  const dispatch = useOrderDispatch();
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const selectedAddons = filter(
    state.visibleOrderItems,
    oi => isAddonProduct(oi) && isProductAvailable(oi),
  );
  const selectQuantity = useCallback(
    (productId, quantity) => {
      const orderItems = [...state.visibleOrderItems];
      const addonIndex = findIndex(orderItems, oi => oi.priceBookEntry.productId === productId);

      orderItems[addonIndex].orderItem.quantity = quantity;

      dispatch({
        type: 'UPDATE',
        payload: {
          visibleOrderItems: [...orderItems],
        },
      });
    },
    [dispatch, state.visibleOrderItems],
  );

  useEffect(() => {
    setTotalPrice(sumBy(selectedAddons, addon => getOrderItemPrice(state, addon)));
  }, [selectedAddons]);

  if (!selectedAddons.length) {
    return null;
  }

  return (
    <>
      <OrderBlock hideValue={state.isPriceHidden} title="Add on products" value={totalPrice}>
        <br />
        {selectedAddons.map(addon => {
          const { priceBookEntry, orderItem } = addon;
          const productId = addon.priceBookEntry.productId;
          const description = addon.orderItem?.description;
          const portalName = priceBookEntry.product.portalName;
          const name = portalName?.length > 0 ? portalName : priceBookEntry.name;
          const quantity = orderItem.quantity;

          return (
            <React.Fragment key={productId}>
              <OrderBlock
                color="#FAFAFA"
                hideValue={state.isPriceHidden}
                title={name}
                value={getOrderItemPrice(state, addon)}
              >
                {description && <ProductDescription description={description} />}
                <br />
                <ProductQuantity
                  quantity={quantity}
                  selectQuantity={quantity => selectQuantity(productId, quantity)}
                  units="Pack"
                />
              </OrderBlock>
              <br />
            </React.Fragment>
          );
        })}
      </OrderBlock>
      <br />
    </>
  );
};
